export class PDFFeaturesIncludeTableConfigs {
  static readonly TableHeaderHeight = 25;
  static readonly DefaultMaxCharsPerLine = 80;
  static readonly DefaultRowHeight = 30;
  static readonly RowHeightLinesMultiplier = 10;
  static readonly CommaAndBlankTextLength = 2;
}
